import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_SandboxFHIR } from '../../modules/ModuleFE_SandboxFHIR/index.js';
import { Base_RequestTemplate } from '../../Page_BaseSandbox/Base_RequestTemplate/index.js';
export class FHIRSandboxRequestTemplates extends Base_RequestTemplate {
    async getTemplates() {
        return ModuleFE_SandboxFHIR.listTemplates();
    }
    renderTemplate(template) {
        return _jsx("div", { className: 'predefined-option__label', children: template.label });
    }
}
//# sourceMappingURL=FHIRSandboxRequestTemplates.js.map